import React, {useState, useEffect} from 'react';

import {service_request as serviceRequestApi} from '~/api/private';
import {Pressable} from '~/components/controls';
import PropTypes from 'prop-types';

const IMG_DEFAULT_WIDTH = 800;

const Thumbnail = ({request_id, message_id, index, data}) => {
  const [size, setSize] = useState({
    width: IMG_DEFAULT_WIDTH,
    height: IMG_DEFAULT_WIDTH,
  });

  useEffect(() => {
    if (data) {
      const img = new Image();
      img.src = data;
      img.onload = () => {
        const ratio = img.height / img.width;
        setSize({width: IMG_DEFAULT_WIDTH, height: IMG_DEFAULT_WIDTH * ratio});
      };
    }
  }, [data]);

  return (
    <Pressable
      onPress={async () => {
        const w = window.open(
          '/attachment.html',
          'bahnkick_image',
          `popup,width=${size.width},height=${size.height}`,
        );

        if (!w) {
          return;
        }

        w.document.addEventListener('click', () => {
          w.close();
        });

        const {result} =
          (await serviceRequestApi.full_image(request_id, message_id, index)) ??
          {};

        if (!result) {
          w.document.body.innerHTML = `<div style='text-align: center; margin-top: 200px;'>Afbeelding laden is mislukt. Probeer het opnieuw.</div>`;
          w.document.close();

          setTimeout(() => {
            w.close();
          }, 2000);
          return;
        }

        setTimeout(() => {
          w.document.body.innerHTML = `<img src="${result}" style="display: block; margin: 0 auto;" height="100%" />`;
          w.document.close();
        }, 500);
      }}>
      <img
        draggable="false"
        alt=""
        style={{
          maxWidth: '50%',
          borderRadius: 10,
        }}
        src={data}
      />
    </Pressable>
  );
};
Thumbnail.propTypes = {
  request_id: PropTypes.any,
  message_id: PropTypes.any,
  index: PropTypes.any,
  data: PropTypes.any,
};

export default Thumbnail;
